<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';

	let tooltip = '';
	let tooltipX = 0;
	let tooltipY = 0;

	const updateTooltip = (event: PointerEvent) => {
		const surface = event.currentTarget as HTMLElement;
		const cell = (event.target as Element | null)?.closest?.(
			'[data-em-heatmap-tooltip], .calendar-heatmap-cell',
		) as HTMLElement | null;
		if (!cell || !surface.contains(cell)) {
			tooltip = '';
			return;
		}

		const nextTooltip = cell.dataset.emHeatmapTooltip || cell.getAttribute('title') || '';
		if (!nextTooltip) {
			tooltip = '';
			return;
		}

		// The design-system heatmap currently uses a native title. Move it to a data
		// attribute so only the consistent in-app hover card is displayed.
		cell.dataset.emHeatmapTooltip = nextTooltip;
		cell.removeAttribute('title');
		const bounds = surface.getBoundingClientRect();
		const localX = event.clientX - bounds.left;
		const localY = event.clientY - bounds.top;
		tooltipX = Math.min(Math.max(localX, 92), Math.max(bounds.width - 92, 92));
		tooltipY = localY > 58 ? localY - 48 : localY + 18;
		tooltip = nextTooltip;
	};
</script>

<div
	class="em-heatmap-hover-surface"
	role="presentation"
	on:pointermove={updateTooltip}
	on:pointerleave={() => (tooltip = '')}
>
	<slot />
	{#if tooltip}
		<div
			class="em-heatmap-hover-popup"
			style={`--em-heatmap-tooltip-x:${tooltipX}px;--em-heatmap-tooltip-y:${tooltipY}px`}
			role="tooltip"
		>
			<Text styleType="body-small" class="text-600">{tooltip}</Text>
		</div>
	{/if}
</div>

<style>
	.em-heatmap-hover-surface {
		position: relative;
		width: 100%;
		min-width: 0;
	}

	.em-heatmap-hover-popup {
		position: absolute;
		left: var(--em-heatmap-tooltip-x);
		top: var(--em-heatmap-tooltip-y);
		z-index: 20;
		max-width: 220px;
		padding: var(--spacing-xs) var(--spacing-s);
		transform: translateX(-50%);
		border: 1px solid var(--color-4);
		border-radius: var(--radius-medium);
		background: var(--surface-glass-fallback-bg);
		box-shadow: var(--shadow-m);
		color: var(--color-on-surface);
		white-space: nowrap;
		pointer-events: none;
	}
</style>
